if (!window.Eurus.loadedScript.includes('product-cart.js')) {
  window.Eurus.loadedScript.push('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        async addToCart(e, required) {
          e.preventDefault();
          
          if (required) {
            var productInfo = this.$el.closest('.product-info');
            if (productInfo) {
              var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
              this.stopAction = false;
              propertiesInput.length && propertiesInput.forEach((input) => {
                if (input.required && input.value == '' || input.classList.contains("validate-checkbox")) {
                  input.classList.add("required-picker");
                  this.stopAction = true;
                }
              });
            }
            if (this.stopAction) {
              return true;
            }
          }

          this.loading = true;

          // Collect all checked checkboxes (gift wrapping and upsell products)
          const itemsToAdd = [];
          const checkedCheckboxes = [];
          
          // Check current scope checkbox
          if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked) {
            checkedCheckboxes.push(this.$refs.gift_wrapping_checkbox);
            if (wrappringVariantId) {
              itemsToAdd.push({ id: wrappringVariantId, quantity: 1 });
            }
          }
          
          // Search for other checked checkboxes in document (for upsell products in different scopes)
          const allCheckboxes = document.querySelectorAll('[x-ref="gift_wrapping_checkbox"]');
          allCheckboxes.forEach(cb => {
            if (cb.checked && !checkedCheckboxes.includes(cb)) {
              checkedCheckboxes.push(cb);
              // If checkbox has a data-variant-id, use that
              if (cb.dataset.variantId) {
                itemsToAdd.push({ id: cb.dataset.variantId, quantity: 1 });
              } else if (wrappringVariantId && !itemsToAdd.find(item => item.id === wrappringVariantId)) {
                // Use the x-data variant ID if not already added
                itemsToAdd.push({ id: wrappringVariantId, quantity: 1 });
              }
            }
          });
          
          // Add all items to cart
          if (itemsToAdd.length > 0) {
            const giftData = { items: itemsToAdd };
    
            const giftResponse = await window.fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(giftData),
            });
    
            const giftResponse1 = await giftResponse.json();
            if (!giftResponse.ok) {
              if (giftResponse1.status == 422) {
                // Find error element in current scope or search in document
                let errorEl = this.$refs.gift_wrapping_error;
                if (!errorEl) {
                  errorEl = document.querySelector('[x-ref="gift_wrapping_error"]');
                }
                if (errorEl) {
                  errorEl.textContent = giftResponse1.description;
                }
                this.loading = false;
                setTimeout(() => {
                  if (errorEl) {
                    errorEl.textContent = "";
                  }
                }, 5000);
              }
              return;
            }
          }

          // Get form by x-ref or by ID from checkbox form attribute
          let productForm = this.$refs.product_form;
          if (!productForm && this.$refs.gift_wrapping_checkbox) {
            const formId = this.$refs.gift_wrapping_checkbox.getAttribute('form');
            if (formId) {
              productForm = document.getElementById(formId);
            }
          }
          
          if (!productForm) {
            console.error('Product form not found');
            this.loading = false;
            return;
          }
          
          let formData = new FormData(productForm);
          formData.append(
            'sections',
            Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          await fetch(`${Eurus.cart_add_url}`, {
            method:'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          }).then(reponse => {
            return reponse.json();
          }).then((response) => {
            if (response.status == '422') {
              if (typeof response.errors == 'object') {
                this.error_message_wrapper = response.errors;
                document.querySelector('.recipient-error-message').classList.remove('hidden');
              } else {
                this.errorMessage = true;
                if(this.$refs.error_message){
                  this.$refs.error_message.textContent = response.description;
                }
                if(this.$refs.error_message_mobile){
                  this.$refs.error_message_mobile.textContent = response.description;
                }
              }
              if (Alpine.store('xMiniCart')) {
                Alpine.store('xMiniCart').reLoad();
              }
            } else {
              document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
              this.error_message_wrapper = {};

              Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
                const sectionElement = document.querySelector(section.selector);
                if (sectionElement) {
                  if (response.sections[section.id])
                    sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
                }
              }));
  
              if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
                Alpine.store('xQuickView').show = false;
              }
              Alpine.store('xPopup').close();
              Alpine.store('xMiniCart').openCart();
              
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            }
          }).catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            this.loading = false;
            // Reset all checked checkboxes
            if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked) {
              this.$refs.gift_wrapping_checkbox.checked = false;
            }
            // Reset other checkboxes in document
            const allCheckboxes = document.querySelectorAll('[x-ref="gift_wrapping_checkbox"]:checked');
            allCheckboxes.forEach(cb => {
              cb.checked = false;
            });
          }) 
        }
      }))
    });
  });
}
